import ChartBarsMeter from './ChartBarsMeter';

export default ChartBarsMeter;
